import React from 'react';

import PageContext from '@zego/context/PageContext';

import Link from '@zego/components/Link';

export const EN_PLAY_STORE_LINK = 'https://zegocover.app.link/PMvfIPTRwT';
export const ES_PLAY_STORE_LINK = 'https://zegocover.app.link/vWSoFL0RwT';

export const getGooglePlayLinkFromLanguage = language => {
  switch (language) {
    case 'es':
      return ES_PLAY_STORE_LINK;
    case 'en':
    default:
      return EN_PLAY_STORE_LINK;
  }
};

const GooglePlayLink = ({ children, ...other }) => (
  <PageContext.Consumer>
    {({ language }) => (
      <Link {...other} href={getGooglePlayLinkFromLanguage(language)}>
        {children}
      </Link>
    )}
  </PageContext.Consumer>
);

export default GooglePlayLink;
